<template>
  <div class="trust-card" :style="cardStyle">
    <div class="trust-card__header">
      <div class="trust-card__badge" :style="badgeStyle">
        <span
          class="material-symbols-rounded trust-card__icon iconfont"
          :class="icon"
        ></span>
      </div>
      <div
        class="trust-card__divider"
        :style="{ backgroundColor: dividerColor }"
      ></div>
    </div>
    <h3 class="trust-card__title">{{ title }}</h3>
    <p class="trust-card__subtitle">{{ subtitle }}</p>
  </div>
</template>

<script>
export default {
  name: "TrustCard",
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    bgColor: {
      type: String,
      default: "#FBF8F3",
    },
    badgeBg: {
      type: String,
      default: "#F2E7D3",
    },
    badgeBorder: {
      type: String,
      default: "#D8C6A2",
    },
    dividerColor: {
      type: String,
      default: "#DDD4C4",
    },
    borderColor: {
      type: String,
      default: null,
    },
  },
  computed: {
    cardStyle() {
      const style = {
        backgroundColor: this.bgColor,
      };
      if (this.borderColor) {
        style.border = `1px solid ${this.borderColor}`;
      }
      return style;
    },
    badgeStyle() {
      return {
        backgroundColor: this.badgeBg,
        border: `1px solid ${this.badgeBorder}`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.trust-card {
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;

  &__header {
    display: flex;
    align-items: center;
    gap: 16px;
    height: 76px;
  }

  &__badge {
    width: 76px;
    height: 76px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  &__icon {
    font-size: 32px;
    color: #0e2746;
  }

  &__divider {
    height: 1px;
    flex: 1;
  }

  &__title {
    font-family: $font-family;
    font-size: 30px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0;
    text-align: left;
  }

  &__subtitle {
    font-family: $font-family;
    font-size: 15px;
    font-weight: normal;
    color: #6a6256;
    line-height: 1.78;
    margin: 0;
    text-align: left;
  }

  @media (max-width: 767px) {
    gap: 8px;

    &__header {
      height: 50px;
    }

    &__badge {
      width: 50px;
      height: 50px;
      border-radius: 10px;
    }

    &__title {
      font-size: 24px;
    }

    &__subtitle {
      font-size: 14px;
    }
  }
}
</style>
